<microsec-form-builder
  #fb
  [fields]="fields"
  [shouldShowActionButtons]="true"
  [submitButtonLabel]="SAVE_CHANGES_LABEL"
  (submitEvent)="onSubmit($event)" />

<ng-template #cpuThresholdField>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <div class="flex flex-row items-center mt-2">
        <div class="flex grow">
          <p-slider class="w-full" [formControlName]="FORM_PARAMS.METRIC_CPU_DEV_THRESHOLD" [step]="1" [min]="0" [max]="100" />
        </div>
        <div class="flex grow-0" style="width: 50px">
          <label class="font-bold ml-4">
            <label class="font-bold"> {{ form.getControlValue(FORM_PARAMS.METRIC_CPU_DEV_THRESHOLD) }}% </label>
          </label>
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #ramThresholdField>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <div class="flex flex-row items-center mt-2">
        <div class="flex grow">
          <p-slider class="w-full" [formControlName]="FORM_PARAMS.METRIC_MEM_DEV_THRESHOLD" [step]="1" [min]="0" [max]="100" />
        </div>
        <div class="flex grow-0" style="width: 50px">
          <label class="font-bold ml-4">
            <label class="font-bold"> {{ form.getControlValue(FORM_PARAMS.METRIC_MEM_DEV_THRESHOLD) }}% </label>
          </label>
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #advancedSettingsButton>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <label class="link" (click)="toggleShowAdvancedSettings()">
        <i [class]="!!showAdvancedSettings ? 'pi pi-chevron-down mr-2' : 'pi pi-chevron-right mr-2'" style="font-size: 0.75rem"> </i>
        Advanced Settings (Requires Retraining)
      </label>
    </ng-container>
  }
</ng-template>
